const PRODUCTION_API_BASE_URL =
  "https://us-central1-livekit-integration-665e3.cloudfunctions.net/api";

// Local UI development should remain usable even when the Functions emulator is
// not running. Set VITE_API_BASE_URL to the emulator URL when working on it.
const getApiBaseUrl = () =>
  import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "") ||
  PRODUCTION_API_BASE_URL;

export const API_BASE_URL = getApiBaseUrl();

// API Endpoints
export const API_ENDPOINTS = {
  CREATE_CHECKOUT: `${API_BASE_URL}/create-checkout`,
  REDEEM_TOKEN: `${API_BASE_URL}/redeem-token`,
  POLAR_WEBHOOK: `${API_BASE_URL}/polar-webhook`,
  TRANSACTION_STATUS: (checkoutId: string) => `${API_BASE_URL}/transaction-status/${checkoutId}`,
  WALLET_TRANSACTIONS: `${API_BASE_URL}/wallet-transactions`,
  TEST: `${API_BASE_URL}/test`,
} as const;
